export function getFileAndFolder(path) {
    const [fileName, ...parts] = path.split('/').reverse();
    const folder = parts.reverse().join('/');
    return [fileName, folder];
}
export const getFileSizeWithUnit = (size) => {
    let sizeText = `${size} bytes`;
    const sizeInKb = 1024;
    const sizeInMB = sizeInKb * 1024;
    const sizeInGB = sizeInMB * 1024;
    if (size >= sizeInKb) {
        if (size < sizeInMB) {
            sizeText = `${Math.round(size / sizeInKb)} KB`;
        }
        else if (size < sizeInGB) {
            sizeText = `${Math.round(size / sizeInMB)} MB`;
        }
        else if (size > sizeInGB) {
            sizeText = `${Math.round(size / sizeInGB)} GB`;
        }
    }
    return sizeText;
};
export const downloadFile = (blob, fileName) => {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.click();
    URL.revokeObjectURL(url);
    a.remove();
};
export const downloadFromUrl = (url) => {
    const a = document.createElement('a');
    a.href = url;
    document.body.appendChild(a);
    a.click();
    a.remove();
};
export const base64ToBlob = (base64, mimeType) => {
    const byteCharacters = atob(base64);
    const byteArrays = [];
    for (let i = 0; i < byteCharacters.length; i += 512) {
        const slice = byteCharacters.slice(i, i + 512);
        const byteNumbers = new Array(slice.length).fill(0).map((_, i) => slice.charCodeAt(i));
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, { type: mimeType });
};
export const getExtensionFromFileName = (fileName) => {
    var _a;
    const baseName = (_a = fileName.split('/').pop()) !== null && _a !== void 0 ? _a : fileName;
    const lastDotIndex = baseName.lastIndexOf('.');
    return lastDotIndex > 0 ? baseName.slice(lastDotIndex + 1).toLowerCase() : '';
};
export const isBase64String = (str) => {
    try {
        const decoded = atob(str);
        return btoa(decoded) === str;
    }
    catch (_a) {
        return false;
    }
};
export const downloadBase64File = (data, fileName, mimeType) => {
    try {
        let blob;
        // Check if it looks like base64 (with or without prefix)
        const cleanData = data.includes(',') ? data.split(',')[1] : data;
        if (isBase64String(cleanData)) {
            // Decode base64
            const binary = atob(cleanData);
            const length = binary.length;
            const bytes = new Uint8Array(length);
            for (let i = 0; i < length; i++) {
                bytes[i] = binary.charCodeAt(i);
            }
            blob = new Blob([bytes], { type: mimeType });
        }
        else {
            // Treat as normal string
            blob = new Blob([data], { type: mimeType || 'text/plain' });
        }
        // Download
        const url = URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = fileName;
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
        URL.revokeObjectURL(url);
    }
    catch (error) {
        console.error('Error downloading file:', error);
    }
};
